import { EnergyContract } from '@/src/types/Account';

export const getActiveContracts = (
  contracts: Array<EnergyContract>,
): Array<EnergyContract> =>
  contracts.filter(({ status: { active } }) => active);
